import React, { useState , useEffect , useRef} from 'react';
import { useParams } from 'react-router-dom';
import './SalesDetails.css';
import Nav from '../Nav/Nav';
import SalesDetailsPro from '../SalesDetailsPro/SalesDetailsPro';
import Footer from '../Footer/Footer';
import buildingData from "../../data/buildings.json";

const SalesDetails = () => {

  const { buildingId, categoryId } = useParams();
  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem('language', JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  const [building, setBuilding] = useState([]);
  
    useEffect(() => {
    const currentBuilding = buildingData.find(
      (item) => item.building_id.toString() === buildingId
    );
    
    if (currentBuilding) {
      setBuilding(currentBuilding);
    }
  }, [buildingId]);
  


  return (
    <>
    <div className="salesdetails-container-up">
      <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
      <div className="salesdetails-container">
      {building && (
      <img
          src={building.building_image_url}
          alt="salesdetails-photo"
          className="salesdetails-image"
        />
      )}
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className='hero-title'>
          <h1 className="overlay-text">
              {'  '}
              <strong>
              <span class="protest-font"></span>
                <img
                  src="/underlined2-1.png"
                  alt="Underline decoration"
                  className="underline-image"
                />
              </strong>{' '}
              
            </h1>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
      <SalesDetailsPro isAlbanian={isAlbanian} buildingId={buildingId} categoryId={categoryId}  />
    </div>
    <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default SalesDetails;
